$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    "thumbs", // gallery all
    "zoom", // zoom icon
    "fullScreen", // full view screen
    "close" // close icon
  ],
  loop: false,
  protect: true
});

